import { useEffect, useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { Navigate, useParams } from "@/lib/router-compat";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/landing/Footer";
import NotFound from "@/pages/NotFound";
import { fetchCategoryBySlug } from "@/lib/products";

/** Äldre URL /produkter/:kategori – vidarebefordrar till tjänstesidan. */
const LegacyCategoryRedirect = () => {
  const params = useParams();
  const categorySlug = params["kategori"] ?? "";
  const [target, setTarget] = useState<string | null | undefined>(undefined);

  useEffect(() => {
    let active = true;
    setTarget(undefined);
    fetchCategoryBySlug(categorySlug)
      .then((cat) => {
        if (!active) return;
        setTarget(cat ? `/${cat.service_slug}` : null);
      })
      .catch(() => active && setTarget(null));
    return () => {
      active = false;
    };
  }, [categorySlug]);

  if (target === undefined) {
    return (
      <div className="min-h-dvh bg-background">
        <Navbar />
        <div className="page-container py-20 text-muted-foreground">Laddar…</div>
        <Footer />
      </div>
    );
  }
  if (target === null) return <NotFound />;
  return <Navigate to={target} replace />;
};

export const Route = createFileRoute("/produkter/$kategori/")({
  head: () => seoHead("/produkter/$kategori"),
  component: LegacyCategoryRedirect,
});
